import React from 'react';
import { Dashboard, PageLayout } from '@components';
import { HeadContent } from '@fourthwall/components';
import { isWebView } from '@fourthwall/utils';
import { AnalyticsToolbar } from '../../analyticsModule/components/AnalyticsToolbar/AnalyticsToolbar';
import { AnalyticsCompareDateRangeSelect } from '../../analyticsModule/components/tools/AnalyticsCompareDateRangeSelect/AnalyticsCompareDateRangeSelect';
import { AnalyticsDateRangeSelect } from '../../analyticsModule/components/tools/AnalyticsDateRangeSelect/AnalyticsDateRangeSelect';
import { AnalyticsGroupBySelect } from '../../analyticsModule/components/tools/AnalyticsGroupBySelect/AnalyticsGroupBySelect';
import { useAnalyticsParams } from '../../modules/AnalyticsParams/hooks/useAnalyticsParams';
import { GoogleAnalyticsBanner } from '../../modules/GoogleAnalytics/components/GoogleAnalyticsBanner/GoogleAnalyticsBanner';
import { GoogleAnalyticsBar } from '../../modules/GoogleAnalytics/components/GoogleAnalyticsBar/GoogleAnalyticsBar';
import * as S from './AnalyticsReports.styled';
import { AnalyticsReportsData } from './components/AnalyticsReportsData/AnalyticsReportsData';
import { useAnalyticsReportsData } from './hooks/useAnalyticsReportsData';
export const AnalyticsReports = () => {
    const { data, isLoading, onDownload } = useAnalyticsReportsData();
    const { dateRange, compareDateRange, groupBy } = useAnalyticsParams();
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Reports", titleTemplate: isWebView() ? 'Reports' : undefined }),
        React.createElement(PageLayout, { size: "full" },
            React.createElement(Dashboard.Section, { name: isWebView() ? undefined : 'Reports' },
                React.createElement(S.Container, null,
                    React.createElement(AnalyticsToolbar, { bottomContent: React.createElement(GoogleAnalyticsBanner, null) },
                        React.createElement(AnalyticsDateRangeSelect, { ...dateRange }),
                        React.createElement(AnalyticsCompareDateRangeSelect, { ...compareDateRange }),
                        React.createElement(AnalyticsGroupBySelect, { ...groupBy }),
                        React.createElement(GoogleAnalyticsBar, null)),
                    React.createElement(AnalyticsReportsData, { data: data, isLoading: isLoading, onDownload: onDownload }))))));
};
